<div class="unsupported">
  <div>
    <p [innerHTML]="'UNSUPPORTED.DESCRIPTION' | t">
      UMMA 홈페이지는 <strong>크롬 브라우저</strong>에 최적화되어 있습니다.
    </p>
    <a href="https://www.google.com/intl/ko/chrome/" target="_blank"
      ><img src="../../../../../assets/images/ico_chrome.svg" alt="" />
      <span [innerHTML]="'UNSUPPORTED.LINK' | t">크롬 브라우저 설치 하기</span></a
    >
  </div>
</div>
